<div class="container">
  <h1 class="header">{{ 'AW-AddWorker' | translate }} {{ worker?.Id ? ' - ' + fullName : '' }}</h1>

  <div class="content-card">
    <mat-horizontal-stepper linear #stepper>
      <!-- First Step -->
      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup" #ngForm="ngForm">
          <ng-template matStepLabel>{{ 'AW-BasicInformation' | translate }}</ng-template>

          <div class="row mb-4">
            <div class="col-12 col-md-6">
              <mat-checkbox formControlName="isForeigner">
                {{ 'Foreigner' | translate }}
              </mat-checkbox>
            </div>
            <div class="col-12 col-md-6 d-flex flex-column align-items-end">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'AW-WorkerLanguage' | translate }}</mat-label>
                <mat-select formControlName="language" required>
                  @for (language of listOfLanguages$ | async; track language) {
                  <mat-option [value]="language.Id">
                    {{ language.Name }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="row employment-type-row">
            <div class="col-12 d-flex flex-column">
              <mat-label class="mat-radio-group-label">{{ 'AW-ChoiceEmploymentType' | translate }}:</mat-label>
              <mat-radio-group formControlName="employmentTypeId" aria-label="Select an option" required>
                @for (employmentType of employmentTypes; track employmentType) {
                <mat-radio-button [value]="employmentType.Id">
                  {{ employmentType.Name }}
                </mat-radio-button>
                }
              </mat-radio-group>
              @if (employmentTypeId.invalid && ngForm.submitted) {
              <mat-error>
                {{ 'ChooseEmploymentType' | translate }}
              </mat-error>
              }
            </div>
          </div>

          <div [visibleWithPermissions]="['DisableNameValidation']" class="row">
            <div class="col-12 col-md-6">
              <mat-checkbox formControlName="disabledNameValidation">
                {{ 'DisableNameValidation' | translate }}
              </mat-checkbox>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'LastName' | translate }}</mat-label>
                <input matInput textCase="title" [textCaseDisabled]="disabledNameValidation.value"
                  placeholder="{{ 'LastName' | translate }}" formControlName="lastName" autocomplete="family-name"
                  required />
                @if (lastName.invalid && lastName.touched) {
                <mat-error>
                  @if (lastName.hasError('titleCase')) {
                  {{ 'TitleCaseRequired' | translate }}
                  } @else {
                  {{ 'InvalidField' | translate }}
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'FirstName' | translate }}</mat-label>
                <input matInput textCase="title" [textCaseDisabled]="disabledNameValidation.value"
                  placeholder="{{ 'FirstName' | translate }}" formControlName="firstName" autocomplete="given-name"
                  required />
                @if (firstName.invalid && firstName.touched) {
                <mat-error>
                  @if (firstName.hasError('titleCase')) {
                  {{ 'TitleCaseRequired' | translate }}
                  } @else {
                  {{ 'InvalidField' | translate }}
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'SecondName' | translate }}</mat-label>
                <input matInput textCase="title" [textCaseDisabled]="disabledNameValidation.value"
                  placeholder="{{ 'SecondName' | translate }}" formControlName="secondName"
                  autocomplete="additional-name" />
                @if (secondName.invalid && secondName.touched) {
                <mat-error>
                  @if (secondName.hasError('titleCase')) {
                  {{ 'TitleCaseRequired' | translate }}
                  } @else {
                  {{ 'InvalidField' | translate }}
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <!-- Date of birth & Pesel -->

          <div class="row">
            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Pesel' | translate }}</mat-label>
                <input matInput appNumbersOnly type="text" placeholder="{{ 'Pesel' | translate }}"
                  formControlName="pesel" autocomplete="pesel" [maxLength]="11" />
                @if (pesel.invalid && pesel.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
                }
              </mat-form-field>
            </div>

            @if (isForeigner.value) {
            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NIP' | translate }}</mat-label>
                <input matInput appNumbersOnly type="text" placeholder="{{ 'NIP' | translate }}" formControlName="nip"
                  autocomplete="nip" [maxLength]="10" />
                @if (nip.invalid && nip.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
                }
              </mat-form-field>
            </div>
            }
          </div>
          @if (isOptionalNipOrPeselInfoVisible) {
          <div class="row" [@inOutAnimation]>
            <div class="col-12">
              <alert #alert [message]="'OptionalNipOrPeselInfo' | translate" alertType="info"></alert>
            </div>
          </div>
          }
          <div class="row">
            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'DateOfBirth' | translate }}</mat-label>
                <input matInput [matDatepicker]="birthDatePicker" formControlName="dateOfBirth" autocomplete="date" />
                <mat-datepicker-toggle [for]="birthDatePicker" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #birthDatePicker startView="multi-year"></mat-datepicker>
                @if (dateOfBirth.invalid && dateOfBirth.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-12 col-lg-6">
              @if (isForeigner.value) {
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Citizenship' | translate }}</mat-label>
                <input matInput type="text" formControlName="citizenship" placeholder="{{ 'Citizenship' | translate }}"
                  [matAutocomplete]="autocompleteCitizenship" required />
                <mat-autocomplete #autocompleteCitizenship="matAutocomplete" [displayWith]="displayValue">
                  @for (citizenship of listOfCitizentship$ | async; track citizenship) {
                  <mat-option [value]="citizenship">
                    {{ citizenship.Name }}
                  </mat-option>
                  }
                </mat-autocomplete>
                @if (citizenship.invalid && citizenship.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
                }
              </mat-form-field>
              }
            </div>
          </div>
          <!-- Document Type & Document Number -->

          @if (isForeigner.value) {
          <div class="row">
            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'IdentityDocumentType' | translate }}</mat-label>
                <mat-select formControlName="identityDocumentTypeId">
                  @for (identityDocument of identityDocumentTypes$ | async; track identityDocument) {
                  <mat-option #matOption [value]="identityDocument.Id">{{
                    identityDocument.Name
                    }}</mat-option>
                  }
                </mat-select>
                @if (identityDocumentTypeId.invalid && identityDocumentTypeId.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-12 col-lg-6">
              <div class="row">
                @if (
                !!selectedIdentityDocumentType?.HasSerialNumber && selectedIdentityDocumentType?.Id ===
                identityDocumentTypeEnum.IdentityCard
                ) {
                <div class="col-6">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'DocumentSerial' | translate }}</mat-label>
                    <input matInput type="text" placeholder="{{ 'DocumentSerial' | translate }}"
                      formControlName="documentSerial" autocomplete="documentSerial" [maxlength]="serialLength"
                      toUppercaseInput />
                    @if (documentSerial.invalid && documentSerial.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'DocumentNumber' | translate }}</mat-label>
                    <input matInput type="text" placeholder="{{ 'DocumentNumber' | translate }}"
                      formControlName="documentNumber" autocomplete="documentNumber" [maxlength]="numberLength" />
                    @if (documentNumber.invalid && documentNumber.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                }
                @if (
                !!selectedIdentityDocumentType?.HasSerialNumber && selectedIdentityDocumentType?.Id !==
                identityDocumentTypeEnum.IdentityCard
                ) {
                <div class="col-12">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ identityDocumentTypeEnum[selectedIdentityDocumentType.Id] + 'Number' | translate
                      }}</mat-label>
                    <input matInput type="text" formControlName="documentNumber" autocomplete="documentNumber"
                      [maxlength]="numberLength" />
                    @if (documentNumber.invalid && documentNumber.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                    }
                  </mat-form-field>
                </div>
                }
              </div>
            </div>
          </div>
          }

          <div fxLayout="row" fxLayoutAlign="end center">
            <button mat-raised-button color="primary" matStepperNext>{{ 'Next' | translate }}</button>
          </div>
        </form>
      </mat-step>

      <!-- Second Step -->
      <mat-step [stepControl]="secondFormGroup">
        <ng-template matStepLabel>{{ 'AW-AdditionalInformation' | translate }}</ng-template>

        <form [formGroup]="secondFormGroup">
          <div class="row">
            <div class="col-12">
              <mat-checkbox class="bold" formControlName="noAccount">
                {{ 'AddWorkerWithoutAccount' | translate }}
              </mat-checkbox>
              <mat-icon class="add-worker-tooltip icon-md"
                [matTooltip]="'AddWorkerWithoutAccountTooltip' | translate">info</mat-icon>
            </div>
          </div>

          @if (timesheetModuleEnabled) {
          <div class="row">
            <div class="col-12">
              <mat-checkbox class="bold" formControlName="isTimesheetSettledIndependently">
                {{ 'IsTimesheetSettledIndependently' | translate }}
              </mat-checkbox>
              <mat-icon class="add-worker-tooltip icon-md"
                [matTooltip]="'IsTimesheetSettledIndependentlyTooltip' | translate">info</mat-icon>
            </div>
          </div>
          }

          <div class="row mb-5">
            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'AW-EmailLogin' | translate }}</mat-label>
                <input matInput textCase="lower" placeholder="{{ 'AW-EmailLogin' | translate }}" formControlName="email"
                  autocomplete="email" required />
                @if (email.invalid && email.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-4 col-lg-2">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'PhoneCode' | translate }}</mat-label>
                <mat-select formControlName="phoneCode" required>
                  @for (phoneCode of listOfPhoneCodes$ | async; track phoneCode) {
                  <mat-option #matOption [value]="phoneCode.Id">{{
                    phoneCode.Prefix | translate
                    }}</mat-option>
                  }
                </mat-select>
                @if (phoneCode.invalid && phoneCode.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-8 col-lg-4">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'MobilePhone' | translate }}</mat-label>
                <input #phoneNumberInput matInput placeholder="{{ 'MobilePhone' | translate }}"
                  formControlName="phoneNumber" autocomplete="phoneNumber" [maxLength]="9" appNumbersOnly required />
                <mat-hint>{{ 'AW-PhoneNumberInsteadEmailHint' | translate }}</mat-hint>
                @if (phoneNumber.invalid && phoneNumber.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <!-- Employer & Company -->

          <div class="row">
            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Employer' | translate }}</mat-label>
                <mat-select formControlName="employer">
                  @for (employer of listOfEmployers$ | async; track employer) {
                  <mat-option #matOption [value]="employer.Id" (onSelectionChange)="setSelectedEmployer(employer)">{{
                    employer.Name | translate }}</mat-option>
                  }
                </mat-select>
                @if (employer.hasError('required') && employer.touched) {
                <mat-error>
                  {{ 'InvalidFieldSelect' | translate }}
                </mat-error>
                }
                @if (employer.invalid && employer.touched && !employer.hasError('required')) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
                }
              </mat-form-field>
            </div>

            @if (isForeigner.value) {
            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Company' | translate }}</mat-label>
                <mat-select formControlName="company" #companySelect>
                  @for (company of listOfCompanies$ | async; track company) {
                  <mat-option #matOption [value]="company.Id">{{ company.Name | translate }}
                  </mat-option>
                  }
                </mat-select>
                @if (company.hasError('required') && company.touched) {
                <mat-error>
                  {{ 'InvalidFieldSelect' | translate }}
                </mat-error>
                }
                @if (company.invalid && company.touched && !company.hasError('required')) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
                }
              </mat-form-field>
            </div>
            }
          </div>

          <!-- Client & EmployerObject -->
          <div class="row">
            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'EmployerObject' | translate }}</mat-label>
                <input #employerObjectInput matInput formControlName="employerObject"
                  placeholder="{{ 'EmployerObject' | translate }}" [matAutocomplete]="autocompleteEmployerObject" />
                <mat-icon matSuffix [matTooltip]="'EmployerObjectFilterHint' | translate" matTooltipPosition="above">info</mat-icon>
                <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
                  @if (isEmployerObjectsLoading) {
                  <mat-option disabled>{{ 'Loading' | translate }}</mat-option>
                  }
                  @for (employerObject of listOfEmployerObjects$ | async; track employerObject) {
                  <mat-option [value]="employerObject">
                    {{ employerObject.Name }}
                  </mat-option>
                  }
                </mat-autocomplete>
                @if (employerObject.hasError('required') && employerObject.touched) {
                <mat-error>
                  {{ 'InvalidFieldSelect' | translate }}
                </mat-error>
                }
                @if (employerObject.invalid && employerObject.touched && !employerObject.hasError('required')) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          @if (isMpkActive) {
          <div class="row">
            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'MPK' | translate }}</mat-label>
                <input matInput placeholder="{{ 'MPK' | translate }}" formControlName="mpk" />
              </mat-form-field>
            </div>
          </div>
          }

          @if (orderItemActive && assignOrderItemPermission) {
          <div class="row">
            <div class="col-12">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'AW-OrderItem' | translate }}</mat-label>
                <mat-select formControlName="orderItem">
                  @for (item of listOfAvailableOrderItems$ | async; track item) {
                  <mat-option #matOption [value]="item">{{ item.Name }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          }

          @if (employerHasDrivers) {
          <div class="row">
            <div class="col-12">
              <mat-checkbox class="bold" formControlName="isDriver">
                {{ 'IsDriver' | translate }}
              </mat-checkbox>
            </div>
          </div>
          }

          @if (recruiterModuleEnabled && recruiterIdActive) {
          <div class="row">
            <div class="col-12">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'AW-RecruiterID' | translate }}</mat-label>
                <mat-select formControlName="recruiterId">
                  <mat-option></mat-option>
                  @for (recruiter of listOfRecruiters$ | async; track recruiter) {
                  <mat-option #matOption [value]="recruiter.Id">{{ recruiter.Name }}</mat-option>
                  }
                </mat-select>
                @if (recruiterId.hasError('required') && recruiterId.touched) {
                <mat-error>
                  {{ 'InvalidFieldSelect' | translate }}
                </mat-error>
                }
                @if (recruiterId.invalid && recruiterId.touched && !recruiterId.hasError('required')) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          }

          <div class="row">
            <div class="col-12">
              <mat-checkbox formControlName="isInvitedToFillWorkerForm">
                {{ 'AW-InviteToFillForm' | translate }}
              </mat-checkbox>
            </div>
          </div>

          <div fxLayout="row" fxLayoutAlign="space-between center">
            <button mat-raised-button color="accent" matStepperPrevious>
              <mat-icon>arrow_back</mat-icon>
              {{ 'Back' | translate }}
            </button>
            <button mat-raised-button color="primary" matStepperNext>{{ 'Next' | translate }}</button>
          </div>
        </form>
      </mat-step>
      <!-- Third Step -->
      @if (isForeigner.value && hasLegalization) {
      <mat-step [stepControl]="thirdFormGroup">
        <ng-template matStepLabel>{{ 'AW-EmploymentData' | translate }}</ng-template>
        <app-employment-data-step [employmentTypeId]="employmentTypeId.value" [companyId]="selectedCompany?.Id"
          [employerObjectId]="employerObject.value?.Id" [formGroup]="thirdFormGroup">
        </app-employment-data-step>
      </mat-step>
      }

      <!-- Fourth Step -->
      @if (isForeigner.value && hasLegalization) {
      <mat-step>
        <ng-template matStepLabel>{{ 'AW-LegalizationDocuments' | translate }}</ng-template>
        <app-leagalization-documents-list [legalizationDocuments]="legalizationDocuments"
          (newLegalizationDocumentEvent)="addLegalizationDocument($event)"
          (deleteLegalizationDocumentEvent)="deleteLegalizationDocument($event)"
          [showDecisionButton]="showDecisionButton"
          [canDeleteUnsavedLegalizationDocuments]="canDeleteUnsavedLegalizationDocuments"></app-leagalization-documents-list>
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <button mat-raised-button color="accent" matStepperPrevious>
            <mat-icon>arrow_back</mat-icon>
            {{ 'Back' | translate }}
          </button>
          <button mat-raised-button color="primary" matStepperNext>{{ 'Next' | translate }}</button>
        </div>
      </mat-step>
      }

      <mat-step>
        <ng-template matStepLabel>{{ 'AW-Summary' | translate }}</ng-template>

        <table>
          <tbody>
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'FullName' | translate }}</td>
              <td class="key-value-row__value">{{ firstName.value }} {{ secondName.value }} {{ lastName.value }}</td>
            </tr>
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'Pesel' | translate }}</td>
              <td class="key-value-row__value">{{ pesel.value }}</td>
            </tr>
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'WAD-Docment' | translate }}</td>
              <td class="key-value-row__value">{{ selectedIdentityDocumentType?.Name }} {{ documentSerial.value }} {{
                documentNumber.value }}</td>
            </tr>
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'Email' | translate }}</td>
              <td class="key-value-row__value">{{ email.value }}</td>
            </tr>
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'MobilePhone' | translate }}</td>
              <td class="key-value-row__value">{{ selectedPhoneCode?.Prefix }} {{ phoneNumber.value }}</td>
            </tr>
            @if (isForeigner.value) {
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'Company' | translate }}</td>
              <td class="key-value-row__value">{{ selectedCompany?.Name }}</td>
            </tr>
            }
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'Employer' | translate }}</td>
              <td class="key-value-row__value">{{ selectedEmployer?.Name }}</td>
            </tr>
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'EmployerObject' | translate }}</td>
              <td class="key-value-row__value">{{ selectedEmployerObject?.Name }}</td>
            </tr>
            @if (orderItem.value) {
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'WAD-OrderItem' | translate }}</td>
              <td class="key-value-row__value">{{ orderItem.value.Name }}</td>
            </tr>
            }
            @if (recruiterModuleEnabled) {
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'AW-RecruiterID' | translate }}</td>
              <td class="key-value-row__value">{{ selectedRecruiter?.Name }}</td>
            </tr>
            }
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'AW-EmploymentType' | translate }}</td>
              <td class="key-value-row__value">{{ employmentType | translate }}</td>
            </tr>
            @if (isForeigner.value) {
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'Citizenship' | translate }}</td>
              <td class="key-value-row__value">{{ citizenship.value?.Name }}</td>
            </tr>
            }
            @if (employerHasDrivers) {
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'IsDriver' | translate }}</td>
              <td class="key-value-row__value">
                @if (isDriver.value) {
                {{ 'Yes' | translate }}
                } @else {
                {{ 'No' | translate }}
                }
              </td>
            </tr>
            }
          </tbody>
        </table>

        <div fxLayout="row" fxLayoutAlign="space-between center">
          <button mat-raised-button color="accent" matStepperPrevious>
            <mat-icon>arrow_back</mat-icon>
            {{ 'Back' | translate }}
          </button>
          <button mat-raised-button color="primary" (click)="onSubmit()">{{ 'Save' | translate }}</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>